define('modules/form_editor/models/radio_group',['require','exports','module','./check_group','./check_radio_option'],function(require, exports, module){
  "use strict";
  var CheckboxGroup = require("./check_group"),
      CheckRadioOption = require("./check_radio_option");

  module.exports = CheckboxGroup.extend({
    name: "input:radio",
    isSocialBindable: true,
    defaultValues: {
      "socialBinding": ""
    },
    initialize: function() {
      module.exports.__super__.initialize.apply(this, arguments);
      this.on("change:socialBinding", this.checkSocialRadios);
    },
    checkSocialRadios: function(model) {
      return this.get("socialBinding")? this.setSocialRadios() : this.unsetSocialRadios();
    },
    setSocialRadios: function() {
      this.items.reset([
        new CheckRadioOption({text: "male", socialBinding: "male"}),
        new CheckRadioOption({text: "female", socialBinding: "female"})
      ]);
    },
    unsetSocialRadios: function() {
      this.items.reset([], {silent: true});
      this.addItem();
    },
  });
});

